import { getAdminUser } from "./auth";

let registeredActivityUserNames = [];

export const userNameToSlug = (name) =>
  String(name || "").toLowerCase().trim().replace(/\s+/g, "-");

export function setAppActivityUserNames(names) {
  registeredActivityUserNames = Array.isArray(names)
    ? names.map((name) => String(name || "").trim()).filter(Boolean)
    : [];
}

export function getAppActivityUsers() {
  return [...registeredActivityUserNames].sort((first, second) =>
    first.localeCompare(second)
  );
}

export const slugToUserName = (slug) =>
  getAppActivityUsers().find((name) => userNameToSlug(name) === slug) || null;

export function getActivityByName() {
  const storedUser = getAdminUser();
  const session = storedUser?.session || storedUser;
  const record = session && typeof session === "object"
    ? { ...storedUser, ...session }
    : storedUser || {};

  return String(
    record?.name ||
    record?.userName ||
    record?.fullName ||
    record?.employeeName ||
    record?.firstName ||
    record?.username ||
    ""
  ).trim();
}

const normalizeActivityValue = (value) => {
  if (value === null || value === undefined) {
    return "";
  }

  if (typeof value === "object") {
    return JSON.stringify(value);
  }

  return String(value).trim();
};

export function buildAppActivityFields({
  activityType,
  initiatedFrom,
  name = "",
  previousValue = null,
  updatedValue = null,
  activityDate,
  createdDate
} = {}) {
  const now = new Date().toISOString();
  const fields = {
    activityType,
    activityBy: getActivityByName(),
    activityDate: activityDate || now,
    initiatedFrom,
    createdDate: createdDate || now
  };

  if (name) {
    fields.name = name;
  }

  if (previousValue !== null && previousValue !== undefined) {
    fields.previousValue = previousValue;
  }

  if (updatedValue !== null && updatedValue !== undefined) {
    fields.updatedValue = updatedValue;
  }

  return fields;
}

export function withAppActivityFields(payload = {}, activityOptions = {}) {
  return {
    ...payload,
    ...buildAppActivityFields(activityOptions)
  };
}

export function buildActivityChangeValues(previousRecord, nextValues, trackedFields = []) {
  const previousChanges = {};
  const updatedChanges = {};

  trackedFields.forEach((field) => {
    const oldValue = previousRecord?.[field];
    const newValue = nextValues?.[field];

    if (normalizeActivityValue(oldValue) === normalizeActivityValue(newValue)) {
      return;
    }

    previousChanges[field] = oldValue ?? "";
    updatedChanges[field] = newValue;
  });

  if (Object.keys(updatedChanges).length === 0) {
    return { previousValue: null, updatedValue: null };
  }

  if (Object.keys(updatedChanges).length === 1) {
    const field = Object.keys(updatedChanges)[0];
    return {
      previousValue: { [field]: previousChanges[field] },
      updatedValue: { [field]: updatedChanges[field] }
    };
  }

  return {
    previousValue: previousChanges,
    updatedValue: updatedChanges
  };
}
